var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5105 79.9966C62.4899 79.7137 79.9756 61.3902 79.9756 39.3999V0.990161C79.9756 0.446114 79.5295 0 78.9854 0H54.3075C53.7634 0 53.3173 0.446114 53.3173 0.990161V3.74304H27.6383C27.0943 3.74304 26.6481 4.18916 26.6481 4.7332V39.9983H0.990907C0.435979 39.9983 -0.0210154 40.4553 0.000746421 41.0102C0.544793 62.8156 18.5201 80.2795 40.5213 79.9966",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1598 57.3744C66.1598 57.3744 66.2466 57.3203 66.2791 57.2879L72.8011 52.9642L69.6541 51.2672L66.507 52.0239L58.1728 20.3423C57.4023 17.4022 54.4614 15.5755 51.4663 16.1916L11.7268 24.2552L10.3269 21.1314L6.89769 27.0116C6.82173 27.1305 6.74577 27.2602 6.68065 27.3791V27.4007C6.00784 28.6545 5.7908 30.1678 6.22488 31.6487L16.6969 68.3024C17.0876 69.6751 18.5092 70.475 19.8874 70.0967L65.3459 57.7527C65.6172 57.677 65.8668 57.5473 66.0947 57.4068L66.1489 57.3744H66.1598Z",
    fill: "#F2F4F7",
    stroke: "#1570EF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0191 53.31L24.1514 66.3134C22.6973 66.7025 21.1997 65.8702 20.7874 64.4218L9.75101 25.8224C8.7852 22.45 10.9122 18.9695 14.3631 18.2669L57.4124 9.5223C60.5595 8.88456 63.6631 10.8086 64.4661 13.9L73.9507 49.9808C74.3305 51.4293 73.4732 52.9209 72.0191 53.31Z",
    fill: "white",
    stroke: "#1570EF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6818 18.5695L11.0752 30.5135L9.72953 25.8224C8.76371 22.4499 10.8907 18.9694 14.3416 18.2668L57.3909 9.53304C60.538 8.8953 63.6416 10.8193 64.4447 13.9107L65.6709 18.5803L65.6818 18.5695Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4329 23.1746C18.7368 24.2447 18.0965 25.304 17.0113 25.5418C15.9153 25.7796 14.7759 25.0879 14.472 24.0178C14.1681 22.9477 14.8084 21.8776 15.9044 21.6506C17.0005 21.4236 18.1291 22.1154 18.4329 23.1855V23.1746Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4439 21.6933C25.7369 22.7526 25.1183 23.8011 24.044 24.0281C22.9697 24.2551 21.8519 23.5741 21.5589 22.504C21.2659 21.4339 21.8845 20.3854 22.9697 20.1584C24.0549 19.9314 25.1509 20.6232 25.4439 21.6825V21.6933Z",
    fill: "#F2F4F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0974 30.5996C11.0974 30.5996 11.4229 27.4434 11.7051 24.2115L10.3269 21.1309L6.89769 27.011C6.82173 27.1299 6.74577 27.2596 6.68065 27.3785V27.4001C6.00784 28.654 5.7908 30.1673 6.22488 31.6481L7.62477 36.5555L11.0974 30.5888V30.5996Z",
    fill: "#1570EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4813 27.9755L33.0343 56.4022C32.8383 57.1426 33.5134 57.8067 34.2537 57.5998L62.0163 49.9787C62.7458 49.7827 62.9853 48.8791 62.4627 48.3347L42.147 27.5291C41.6135 26.9847 40.6772 27.2242 40.4813 27.9646V27.9755Z",
    fill: "#F2F4F7",
    stroke: "#1570EF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4434 35.4766L45.8168 44.1211",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.353 48.3456C48.5381 49.0206 48.1135 49.7174 47.4058 49.9025C46.6981 50.0875 45.9687 49.7065 45.7836 49.0315C45.5985 48.3565 46.0231 47.6597 46.7308 47.4746C47.4385 47.2895 48.157 47.6814 48.3421 48.3456H48.353Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.017b616ea56d56fbe81d4baaf6a5f6a2.svg";
export { ForwardRef as ReactComponent };